import { render } from "./CommitmentForm.vue?vue&type=template&id=dd85394a&scoped=true"
import script from "./CommitmentForm.vue?vue&type=script&lang=js"
export * from "./CommitmentForm.vue?vue&type=script&lang=js"

import "./CommitmentForm.vue?vue&type=style&index=0&id=dd85394a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd85394a"]])

export default __exports__